<template lang="pug">
  #app
    nav.navbar(role="navigation", aria-label="main navigation").is-primary.is-fixed-top
      .navbar-brand()
        router-link(:to="{name: 'Welcome'}").navbar-item.logo
          img(:src='require("./assets/logo.png")', alt='OCTea', width=200, height=52)#logo

        .burger.navbar-burger(ref="burger", :class="{'is-active': menuActive}", @click="toggleMenu")
          span
          span
          span

      .navbar-menu(:class="{'is-active': menuActive}", @click='closeMenu')
        .navbar-start
        .navbar-end
          router-link(:to="{name: 'ReleaseNotes'}").navbar-item
            span.icon
              fa-icon(icon='newspaper')
            span News

          router-link(:to="{name: 'Settings'}").navbar-item
            span.icon
              fa-icon(icon='cog')
            span Settings

          a.navbar-item(data-social-network="Twitter", data-social-action="tweet", data-social-target="https://octea.ndim.space", target="_blank", href="https://twitter.com/intent/tweet?text=I brew my tea with OCTea&amp;hashtags=tea&amp;url=https://octea.ndim.space&amp;via=sseemayer")
            .button.is-link
              span.icon
                fa-icon(:icon='{"prefix": "fab", "iconName": "twitter"}')
              span Tweet

    section.section.is-spaced
      .container
        router-view

    footer.footer
      img.teacup(src="./assets/teacup.png", alt="Teacup")

      p made with&nbsp;
        fa-icon(icon='heart')
        | &nbsp;for tea by &nbsp;
        a(href="https://www.reddit.com/u/sseemayer") /u/sseemayer
      p.is-size-7 Icon by&nbsp;
       a(href="http://www.freepik.com", title="Freepik") Freepik
       | &nbsp;from&nbsp;
       a(href="https://www.flaticon.com/", title="Flaticon") www.flaticon.com
       | . Used under&nbsp;
       a(href="http://creativecommons.org/licenses/by/3.0/", title="Creative Commons BY 3.0", target="_blank") CC 3.0 BY
       | &nbsp;license
      p.is-size-7 Chime sound by&nbsp;
        a(href="https://freesound.org/people/LaCezio/sounds/320492/") LaCezio
        | . Used under&nbsp;
        a(href="https://creativecommons.org/licenses/by-nc/3.0/", title="Creative Commons BY-NC 3.0", target="_blank") CC BY-NC 3.0
        | &nbsp;license
</template>

<script>

import '../node_modules/bulma-slider/dist/js/bulma-slider.js'

export default {
  name: 'app',
  data () {
    return {
      menuActive: false
    }
  },
  mounted () {
    window.onbeforeunload = null
  },
  methods: {
    toggleMenu () {
      this.menuActive = !this.menuActive
    },
    closeMenu () {
      this.menuActive = false
    }
  }
}
</script>

<style lang="sass">
.title
  display: flex
  align-items: center
  font-size: 250%

  img
    padding: -10px

span
  padding-left: 20px

.controls
  float: right

.navbar-item.logo
  padding: 0
  margin: 0

#logo
  padding: 0
  margin: 0
  max-height: none
  height: 52px
  max-width: none

.teacup
  float: left
  margin: 0 20px 20px 0
  height: 60px
  width: auto

</style>
